import { useEffect, useRef, useCallback } from 'react';

export const usePolling = (fetchFunction, interval = 5000) => {
  const intervalRef = useRef(null);

  const startPolling = useCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      fetchFunction();
    }, interval);
  }, [fetchFunction, interval]);

  const stopPolling = useCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  }, []);

  /**
   * Cleanup function to stop polling when the component using this hook unmounts.
   */
  useEffect(() => {
    return () => stopPolling();
  }, [stopPolling]);

  return { startPolling, stopPolling };
};
